import { Divider } from '@mui/material';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Resource } from 'sr-types/lib/search/v1/graphql';
import { V } from '../../common/Layout';
import SectionTitle from '../../common/components/SectionTitle';
import { StepsIndexConstant } from '../../common/components/Stepper';
import { useStepper } from '../../common/components/StepperContext';
import { FormContext } from '../../common/form/FormContext';
import BlankCreateResourceSelect from './BlankCreateResourceSelect';
import ResourceTemplatesDataGallery from './ResourceTemplatesDataGallery';
import { createResourceStepperExistingData, ResourceStepperDataType } from './resourceStepperUtils';

export default ({
    isHireResource = false,
    isResourceTemplatesDataLoading = false
}: {
    isHireResource?: boolean;
    isResourceTemplatesDataLoading?: boolean;
}) => {
    const { state } = useContext(FormContext);
    const { activeStep, setStepCompletion, getStepData, setExistingStepData, getTemplateData } = useStepper();

    const selectedTemplate = getStepData(StepsIndexConstant.zero);
    const templateData = getTemplateData(StepsIndexConstant.zero);
    const selectedResourceTemplates = templateData?.filter((resource: Resource) => resource.type === state.type);
    const [isCreateBlankActivated, setIsCreateBlankActivated] = useState<boolean>(
        Boolean(!selectedTemplate?.selectedTemplateId)
    );
    const [isTemplateActivated, setIsTemplateActivated] = useState<boolean>(
        Boolean(selectedTemplate?.selectedTemplateId)
    );

    useEffect(() => {
        setStepCompletion(activeStep, !!state?.type && (isCreateBlankActivated || isTemplateActivated));
    }, [state?.type, isTemplateActivated, isCreateBlankActivated, setStepCompletion, activeStep]);

    const handleActivatedCreateStates = useCallback(
        (blankActive: boolean, templateActive: boolean) => {
            setIsCreateBlankActivated(selectedResourceTemplates?.length === 0 || blankActive);
            setIsTemplateActivated(templateActive);
        },
        [selectedResourceTemplates?.length]
    );

    const handleStepperData = useCallback(
        (data: ResourceStepperDataType) => {
            setExistingStepData(
                createResourceStepperExistingData(
                    {
                        ...data
                    },
                    isHireResource
                )
            );
        },
        [isHireResource, setExistingStepData]
    );

    return (
        <V sx={{ display: !state?.type ? 'none' : 'block', p: 2, height: 'fit-content' }}>
            <BlankCreateResourceSelect
                isCreateBlankActivated={isCreateBlankActivated}
                handleActivatedCreateStates={handleActivatedCreateStates}
                handleStepperData={handleStepperData}
            />
            <Divider sx={{ marginY: 1, width: '100%' }} />
            <SectionTitle i18nToken="form.template.choose" containerSx={{ textTransform: 'uppercase', mb: 2 }} />
            <ResourceTemplatesDataGallery
                handleActivatedCreateStates={handleActivatedCreateStates}
                handleStepperData={handleStepperData}
                isResourceTemplatesDataLoading={isResourceTemplatesDataLoading}
            />
        </V>
    );
};
